import Navbar from '@web/Navbar'
import HeroRexLogo from './HeroRexLogo'
import HeroWave from './HeroWave'
import { InternalHero } from '@web/components/InternalHero'

export function Hero({
  isInternalPage,
  waveColor,
}: {
  isInternalPage?: boolean
  waveColor?: string
}) {
  return <>{isInternalPage ? <InternalHero waveColor={waveColor} /> : <MainHero />}</>
}

const MainHero = () => {
  return (
    <div className="bg-neutral-50">
      <div className="absolute inset-0 z-10 bg-gradient-to-b from-black/70 to-transparent" />
      {/* HEADER */}
      <header className="absolute inset-x-0 top-0 z-50">
        <Navbar />
      </header>
      <section
        className="relative h-screen bg-cover bg-no-repeat px-6 lg:px-8"
        style={{
          backgroundImage: `url('/website/hero_background.jpg')`,
          backgroundPosition: '100% 100%',
        }}
      >
        <HeroRexLogo />
        <HeroWave />
      </section>
    </div>
  )
}

export default Hero
